export const COMP_FIELDS = {
    id: 'id',
    date: 'التاريخ',
    time: 'الوقت',
    storeName: 'المتجر',
    branchName: 'الفرع',
    appKey: 'معرف المتجر',
    appBranchId: 'معرف الفرع',
    app: 'التطبيق',
    orderId: 'رقم الطلب',
    orderStatus: 'حالة الطلب',
    orderAmount: 'قيمة الطلب',
    enduranceAmount: 'قيمة التحمل',
    refundAmount: 'قيمة الاسترداد',
    cause: 'السبب'
}
export const COMP_FIELDS2 = {
    id: 'id',
    date: 'date',
    time: 'time',
    storeName: 'storeName',
    branchName: 'branchName',
    storeId: 'storeId',

    appKey: 'appKey',
    branchRef: 'branchRef',

    appBranchId: 'appBranchId',
    app: 'app',
    orderId: 'orderId',
    orderStatus: 'orderStatus',
    orderAmount: 'orderAmount',
    enduranceAmount: 'enduranceAmount',
    refundAmount: 'refundAmount',
    cause: 'cause'
}
